import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import * as PropTypes from 'prop-types';
import { DialogDecorated, DialogBody, DialogFooter, DialogTitle } from 'components/redux-dialog';
import { Button, ButtonContainer } from 'components/button';
import { hideDialogAction } from 'components/redux-dialog/actions';
import { deleteVideoAction } from 'common/actions';

export const DELETE_MY_VIDEO_DIALOG = 'deleteMyVideoDialog';

export const DeleteMyVideoDialog = connect(false, (dispatch, props) => ({
  hideDialog: () => dispatch(hideDialogAction(DELETE_MY_VIDEO_DIALOG)),
  deleteVideo: () => dispatch(deleteVideoAction(props.video.id, true)),
}))(({ hideDialog, deleteVideo, video }) => {
  const { t } = useTranslation();

  return (
    <DialogDecorated dialogName={DELETE_MY_VIDEO_DIALOG}>
      <DialogTitle>
        <h2>{t('delete_video')}</h2>
      </DialogTitle>
      <DialogBody>
        <div className="ct-stp2-dialog-body">
          <p>{t('delete_video_text_1', { videoTitle: video ? video.title : '' })}</p>
          <p>{t('delete_video_text_2')}</p>
        </div>
      </DialogBody>
      <DialogFooter>
        <ButtonContainer>
          <Button onClick={() => hideDialog()} secondary={true}>
            {t('cancel')}
          </Button>
          <Button onClick={() => deleteVideo()}>{t('delete')}</Button>
        </ButtonContainer>
      </DialogFooter>
    </DialogDecorated>
  );
});

DeleteMyVideoDialog.propTypes = {
  video: PropTypes.object,
};
